




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VToolbar from "../../../ui/common/components/VToolbar.vue";
import ExpenseForm from "../components/ExpenseForm.vue";
import { Expense, getExpense } from "../../../api/cost/expenses-api";

/**
 * 経費の編集ページ
 */
@Component({
  components: {
    VToolbar,
    ExpenseForm
  }
})
export default class ExpenseEditPage extends Vue {
  @Prop({ required: true }) expenseId!: string;

  expense: Expense | null = null;

  saving = false;
  showSaveAlert = false;

  @Watch("expenseId", { immediate: true })
  onExpenseChanged(expenseId: string) {
    this.initExpense(expenseId);
  }

  /**
   * 経費を読み込む
   */
  async initExpense(expenseId: string) {
    this.expense = await getExpense(expenseId);
    this.saving = false;
  }

  handleExpenseChange(expense: Expense) {
    this.expense = expense;
  }

  /**
   * 経費を保存する
   */
  async saveExpense() {
    this.saving = true;
    const form = this.$refs["form"] as ExpenseForm;
    await form
      .submit()
      .then(() => {
        this.showSaveAlert = true;
        this.initExpense(this.expenseId);
      })
      .catch((e: Error) => {
        alert(e.message);
      })
      .finally(() => {
        this.saving = false;
      });
  }
}
